export const chakras = [
  { id: "corona", color: "#8B7BAF", name: "Corona", icon: "👑", subtitle: "Para cuando te duele la cabeza" },
  { id: "tercer-ojo", color: "#C4A5E0", name: "Tercer Ojo", icon: "👁️", subtitle: "Para cuando te duele la frente" },
  { id: "garganta", color: "#9CCFE7", name: "Garganta", icon: "🗣️", subtitle: "Para cuando te duele la garganta" },
  { id: "corazon", color: "#A8D5BA", name: "Corazón", icon: "💚", subtitle: "Para cuando te duele el pecho" },
  { id: "plexo", color: "#FFD166", name: "Plexo Solar", icon: "⚡", subtitle: "Para cuando te duele el estómago" },
  { id: "sacro", color: "#FFB084", name: "Sacro", icon: "🌊", subtitle: "Para cuando te duele el bajo vientre" },
  { id: "raiz", color: "#FF8B7B", name: "Raíz", icon: "🌳", subtitle: "Para cuando te duele la parte de abajo" },
];

export const CYCLE = 60;
